<template>
  <el-row>
    <el-col :span="24" :lg="24">
      <el-form :model="query" ref="query" :show-message="true" :hide-required-asterisk="true">
        <!-- 対象環境 -->
        <el-row :gutter="10" class="mt">
          <el-col :span="24">
            <el-form-item>
              <el-col :span="6" class="center-text">
                <div class="label-style">
                  対象環境
                </div>
              </el-col>
              <el-col :span="18">
                <el-radio-group v-model="query.environment" :disabled="disabled" @change="changeValue">
                  <el-radio label="dev">「TRY/DEV」（開発環境）</el-radio>
                  <el-radio label="pp">「TEST/PP」（検証環境）</el-radio>
                  <el-radio label="prod">「号口/PROD」（本番環境）</el-radio>
                </el-radio-group>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 対象CID -->
        <el-row :gutter="10" class="mt">
          <el-col :span="24">
            <el-form-item prop="cid" ref="cidRef">
              <el-col :span="6" class="center-text">
                <span slot="label"></span>
                <div class="label-cid-style">
                  対象CID
                </div>
              </el-col>

              <el-col :span="3">
                <el-radio-group v-model="query.cidType" :disabled="disabled" @change="changeValue">
                  <div>
                    <el-radio label="binary">バイナリ</el-radio>
                  </div>
                  <div class="radio-top">
                    <el-radio label="encoded">エンコード済</el-radio>
                  </div>
                </el-radio-group>
              </el-col>

              <el-col :span="8">
                <div class="input-binary-top">
                  <el-input v-model="cidBinary" size="large" :BgColor="cidBgColor.binary" :validate-event="false" :readonly="readonlyBinary"></el-input>
                </div>
              </el-col>
              <el-col :span="1">
                <div class="input-binary-top">
                  <el-button size="small" type="primary" @click="search('query')" style="width:185%;">取得</el-button>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="input-encoded-top">
                  <el-input v-model="query.cid" size="large" :BgColor="cidBgColor.encoded" :validate-event="false" :readonly="readonlyEncoded"></el-input>
                </div>
              </el-col>
              <el-col :span="1">
                <div class="input-encoded-top">
                  <el-button size="small" type="info" @click="clear('query')">クリア</el-button>
                </div>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="btn-update-center">
              <el-button size="small" type="warning" :disabled="btnUpdateDisable" @click="update('query')" style="width:6.5%;">更新</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <!-- 編集項目チェックエラー -->
      <div id="div-error-messages">
        <!-- チェックエラー情報 -->
        <el-table :data="allErrorMessages" :show-header="false" empty-text=" " :style="styleType">
          <el-table-column
            prop="leftError"
            min-width="100%"
            label="">
          </el-table-column>
        </el-table>
      </div>

      <!-- CidProrerty情報 -->
      <div v-show="isShowCidProrerty">
        <el-row :gutter="10" class="mt-cid-info">
          <el-col :span="6">
            <div class="title-style ">
              ■CidProrerty
            </div>
          </el-col>
        </el-row>

        <el-form :model="cidProrertyInfo">
          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    cid<br>SDカード識別ID
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="cidProrertyInfo.cid" size="large" readonly></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    all_update_term<br>全地図更新期限 (v2.1)
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="cidProrertyInfo.all_update_term" size="large" :BgColor="cidProrertyAttr.all_update_term.bgColor" @change="changeCidBgColor('all_update_term')" :readonly="cidProrertyAttr.all_update_term.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    create_time<br>登録日時
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="cidProrertyInfo.create_time" size="large" :BgColor="cidProrertyAttr.create_time.bgColor" @change="changeCidBgColor('create_time')" :readonly="cidProrertyAttr.create_time.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    diff_update_term<br>差分地図地図更新期限 (v2.1)
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="cidProrertyInfo.diff_update_term" size="large" :BgColor="cidProrertyAttr.diff_update_term.bgColor" @change="changeCidBgColor('diff_update_term')" :readonly="cidProrertyAttr.diff_update_term.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    hash_salt<br>ハッシュソルト
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="cidProrertyInfo.hash_salt" size="large" :BgColor="cidProrertyAttr.hash_salt.bgColor" @change="changeCidBgColor('hash_salt')" :readonly="cidProrertyAttr.hash_salt.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    initial_map_ver<br>初期マップバージョン
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="cidProrertyInfo.initial_map_ver" size="large" :BgColor="cidProrertyAttr.initial_map_ver.bgColor" @change="changeCidBgColor('initial_map_ver')" :readonly="cidProrertyAttr.initial_map_ver.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    management_info<br>管理情報
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input type="textarea" v-model="cidProrertyInfo.management_info" class="textarea-style" size="large" :rows="2"
                    :BgColor="cidProrertyAttr.management_info.bgColor" @change="changeCidBgColor('management_info')"
                    :readonly="cidProrertyAttr.management_info.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    run100k<br>VINロックフラグ
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="cidProrertyInfo.run100k" size="large" :BgColor="cidProrertyAttr.run100k.bgColor" @change="changeCidBgColor('run100k')" :readonly="cidProrertyAttr.run100k.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    start_date<br>利用開始日 (v2.1)
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="cidProrertyInfo.start_date" size="large" :BgColor="cidProrertyAttr.start_date.bgColor" @change="changeCidBgColor('start_date')" :readonly="cidProrertyAttr.start_date.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    update_time<br>更新日時
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="cidProrertyInfo.update_time" size="large" :BgColor="cidProrertyAttr.update_time.bgColor" @change="changeCidBgColor('update_time')" :readonly="cidProrertyAttr.update_time.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- LatestMapGuaranteeHistory情報 -->
      <div v-show="isShowMapHistory" class="div-style">
        <el-row :gutter="10" class="mt-cid-info">
          <el-col :span="6">
            <div class="title-style ">
              ■LatestMapGuaranteeHistory
            </div>
          </el-col>
        </el-row>

        <el-form :model="mapHistoryInfo">
          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    cid<br>SDカード識別ID
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="mapHistoryInfo.cid" size="large" readonly></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    create_time<br>登録日時
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="mapHistoryInfo.create_time" size="large" :BgColor="mapHistoryAttr.create_time.bgColor" @change="changeMapBgColor('create_time')" :readonly="mapHistoryAttr.create_time.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    fs_applied<br>SD復旧フラグ
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="mapHistoryInfo.fs_applied" size="large" :BgColor="mapHistoryAttr.fs_applied.bgColor" @change="changeMapBgColor('fs_applied')" :readonly="mapHistoryAttr.fs_applied.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    hash_salt<br>ハッシュソルト
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="mapHistoryInfo.hash_salt" size="large" :BgColor="mapHistoryAttr.hash_salt.bgColor" @change="changeMapBgColor('hash_salt')" :readonly="mapHistoryAttr.hash_salt.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt">
            <el-col :span="24">
              <el-form-item>
                <el-col :span="6" class="center-text">
                  <div class="result-label-style">
                    latest_map_ver<br>実行バージョン
                  </div>
                </el-col>
                <el-col :span="15">
                  <el-input v-model="mapHistoryInfo.latest_map_ver" size="large" :BgColor="mapHistoryAttr.latest_map_ver.bgColor" @change="changeMapBgColor('latest_map_ver')" :readonly="mapHistoryAttr.latest_map_ver.readonly ? false:'readonly'"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-col>
  </el-row>

</template>

<script>
import Vue from "vue"
import axios from 'axios'
import { messages } from '@/common/messages'
import { constants } from '@/common/constants'
import commonUtil from '@/common/commonUtil'

export default {
  data () {
    return {
      // CidProrerty情報が表示されない
      isShowCidProrerty: false,
      // LatestMapGuaranteeHistory情報が表示されない
      isShowMapHistory: false,
      // バイナリは書き込み可能
      readonlyBinary: false,
      // エンコード済は書き込み不可
      readonlyEncoded: true,
      // 更新ボタン：非活性
      btnUpdateDisable: true,
      // 対象環境と対象CIDラジオボタンが活性であること
      disabled: false,
      // 対象CID背景色
      cidBgColor: {
        binary: '',
        encoded: 'gray'
      },
      // 検索条件
      query: {
        environment: constants.CHECK_FILE_NAME[2],
        cidType: constants.CID_TYPE[0],
        cid: ''
      },
      cidBinary: '',
      // CidProrerty情報
      cidProrertyInfo: {
        cid: '',
        all_update_term: '',
        create_time: '',
        diff_update_term: '',
        hash_salt: '',
        initial_map_ver: '',
        management_info: '',
        run100k: '',
        start_date: '',
        update_time: ''
      },
      // LatestMapGuaranteeHistory情報
      mapHistoryInfo: {
        cid: '',
        create_time: '',
        fs_applied: '',
        hash_salt: '',
        latest_map_ver: ''
      },
      // ダウンロード抑制期限情報
      downloadDeadlineInfo: {
        CS_suppressterm: '',
        download_deadline: ''
      },
      // 初期化: readonly属性と背景色
      cidProrertyAttr: {},
      mapHistoryAttr: {},
      // CID情報取得API呼び出しで返される結果
      responseData: {
        cidProperty: {},
        latestMapGuaranteeHistory: {}
      },
      // エラー
      allErrorMessages: [],
      // エラー: css style
      styleType: 'display: none'
    }
  },
  created () {
    Vue.$log.info('Update.vue')

    // 編集の制限、背景色設定
    this.propertyInit()
  },
  methods: {
    // 編集の制限、背景色設定
    propertyInit() {
      // CidProrerty詳細情報：編集の制限、背景色
      for (let editItem in constants.CID_PRORERTY) {
        let itemProperty = {}
        // prod環境を選択する場合、各項目をReonOnlyにする
        if (this.query.environment == constants.CHECK_FILE_NAME[1]){
          itemProperty['readonly'] = false
        } else {
          itemProperty['readonly'] = constants.CID_PRORERTY[editItem]
        }
        if (constants.CID_PRORERTY[editItem]) {
          itemProperty['bgColor'] = constants.bgColor[0]
        } else {
          itemProperty['bgColor'] = ''
        }
        this.cidProrertyAttr[editItem] = itemProperty
      }

      // LatestMapGuaranteeHistory詳細情報：編集の制限、背景色
      for (let editItem in constants.LATEST_MAP_GUARANTEE_HISTORY) {
        let itemProperty = {}
        // prod環境を選択する場合、各項目をReonOnlyにする
        if (this.query.environment == constants.CHECK_FILE_NAME[1]){
          itemProperty['readonly'] = false
        } else {
          itemProperty['readonly'] = constants.LATEST_MAP_GUARANTEE_HISTORY[editItem]
        }
        if (constants.LATEST_MAP_GUARANTEE_HISTORY[editItem]) {
          itemProperty['bgColor'] = constants.bgColor[0]
        } else {
          itemProperty['bgColor'] = ''
        }
        this.mapHistoryAttr[editItem] = itemProperty
      }

    },
    // 更新ボタンの状態変更
    changeUpdateStatus() {
      //
      let isAllGreen = true
      Object.keys(this.cidProrertyAttr).forEach((key) => {
        if (this.cidProrertyAttr[key].bgColor == constants.bgColor[1]) {
          isAllGreen = false
        }
      })

      Object.keys(this.mapHistoryAttr).forEach((key) => {
        if (this.mapHistoryAttr[key].bgColor == constants.bgColor[1]) {
          isAllGreen = false
        }
      })


      if (!this.btnUpdateDisable && isAllGreen && constants.CHECK_FILE_NAME[1]) {
        this.btnUpdateDisable = true
      } else if (this.btnUpdateDisable && !isAllGreen) {
        this.btnUpdateDisable = false
      }
    },
    // CidProperty情報に値に変化がある
    changeCidBgColor(itemName) {
      switch (itemName) {
        case 'all_update_term':
          if (this.cidProrertyInfo.all_update_term == this.responseData.cidProperty.all_update_term) {
            this.cidProrertyAttr.all_update_term.bgColor = constants.bgColor[0]
          } else {
            this.cidProrertyAttr.all_update_term.bgColor = constants.bgColor[1]
          }

          break
        case 'create_time':
          if (this.cidProrertyInfo.create_time == this.responseData.cidProperty.create_time) {
            this.cidProrertyAttr.create_time.bgColor = constants.bgColor[0]
          } else {
            this.cidProrertyAttr.create_time.bgColor = constants.bgColor[1]
          }

          break
        case 'diff_update_term':
          if (this.cidProrertyInfo.diff_update_term == this.responseData.cidProperty.diff_update_term) {
            this.cidProrertyAttr.diff_update_term.bgColor = constants.bgColor[0]
          } else {
            this.cidProrertyAttr.diff_update_term.bgColor = constants.bgColor[1]
          }

          break
        case 'hash_salt':
          if (this.cidProrertyInfo.hash_salt == this.responseData.cidProperty.hash_salt) {
            this.cidProrertyAttr.hash_salt.bgColor = constants.bgColor[0]
          } else {
            this.cidProrertyAttr.hash_salt.bgColor = constants.bgColor[1]
          }

          break
        case 'initial_map_ver':
          if (this.cidProrertyInfo.initial_map_ver == this.responseData.cidProperty.initial_map_ver) {
            this.cidProrertyAttr.initial_map_ver.bgColor = constants.bgColor[0]
          } else {
            this.cidProrertyAttr.initial_map_ver.bgColor = constants.bgColor[1]
          }

          break
        case 'management_info':
          if (this.cidProrertyInfo.management_info == this.responseData.cidProperty.management_info) {
            this.cidProrertyAttr.management_info.bgColor = constants.bgColor[0]
          } else {
            this.cidProrertyAttr.management_info.bgColor = constants.bgColor[1]
          }

          break
        case 'run100k':
          if (this.cidProrertyInfo.run100k == this.responseData.cidProperty.run100k) {
            this.cidProrertyAttr.run100k.bgColor = constants.bgColor[0]
          } else {
            this.cidProrertyAttr.run100k.bgColor = constants.bgColor[1]
          }

          break
        case 'start_date':
          if (this.cidProrertyInfo.start_date == this.responseData.cidProperty.start_date) {
            this.cidProrertyAttr.start_date.bgColor = constants.bgColor[0]
          } else {
            this.cidProrertyAttr.start_date.bgColor = constants.bgColor[1]
          }

          break
        case 'update_time':
          if (this.cidProrertyInfo.update_time == this.responseData.cidProperty.update_time) {
            this.cidProrertyAttr.update_time.bgColor = constants.bgColor[0]
          } else {
            this.cidProrertyAttr.update_time.bgColor = constants.bgColor[1]
          }

          break
        default:
          break
      }

      // vueビュー強制リフレッシュ
      this.$forceUpdate()

      // 更新ボタンの状態変更
      this.changeUpdateStatus()
    },
    // LatestMapGuaranteeHistory情報に値に変化がある
    changeMapBgColor(itemName) {
      switch (itemName) {
        case 'create_time':
          if (this.mapHistoryInfo.create_time == this.responseData.latestMapGuaranteeHistory.create_time) {
            this.mapHistoryAttr.create_time.bgColor = constants.bgColor[0]
          } else {
            this.mapHistoryAttr.create_time.bgColor = constants.bgColor[1]
          }

          break
        case 'fs_applied':
          if (this.mapHistoryInfo.fs_applied == this.responseData.latestMapGuaranteeHistory.fs_applied) {
            this.mapHistoryAttr.fs_applied.bgColor = constants.bgColor[0]
          } else {
            this.mapHistoryAttr.fs_applied.bgColor = constants.bgColor[1]
          }

          break
        case 'hash_salt':
          if (this.mapHistoryInfo.hash_salt == this.responseData.latestMapGuaranteeHistory.hash_salt) {
            this.mapHistoryAttr.hash_salt.bgColor = constants.bgColor[0]
          } else {
            this.mapHistoryAttr.hash_salt.bgColor = constants.bgColor[1]
          }

          break
        case 'latest_map_ver':
          if (this.mapHistoryInfo.latest_map_ver == this.responseData.latestMapGuaranteeHistory.latest_map_ver) {
            this.mapHistoryAttr.latest_map_ver.bgColor = constants.bgColor[0]
          } else {
            this.mapHistoryAttr.latest_map_ver.bgColor = constants.bgColor[1]
          }

          break
        default:
          break
      }

      // vueビュー強制リフレッシュ
      this.$forceUpdate()

      // 更新ボタンの状態変更
      this.changeUpdateStatus()
    },

    // 使用して文字列が16進数かどうかを判別
    isHexStr(hexStr) {
      const hexRegex = /^[A-Fa-f0-9]+$/

      return hexRegex.test(hexStr)
    },
    // 使用して文字列がBase64かどうかを判別
    isBase64Str(base64Str) {
      const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/

      return base64Regex.test(base64Str)
    },
    // 16進文字列からBase64符号化された文字列に変換する
    hexTobase64String(hexStr) {
      let hexStrNoSpaces = hexStr.replaceAll(' ', '')

      // Base64符号化された文字列をチェック
      const isHexFlag = this.isHexStr(hexStrNoSpaces)
      if (isHexFlag) {
        try {
          const base64Str = Buffer.from(hexStrNoSpaces, 'hex').toString('base64')

          // 画面表示
          this.query.cid = base64Str

          // エンコード成功
          return true
        } catch (error) {
          Vue.$log.info('-----------------エンコード失敗の場合---------------------')
          Vue.$log.info(error)
        }
      }

      // エンコード失敗
      return false
    },
    // 対象環境と対象CIDラジオボタンを切り替え
    changeValue() {
      // CidProperty情報が表示されない
      this.isShowCidProrerty = false

      // LatestMapGuaranteeHistory情報が表示されない
      this.isShowMapHistory = false


      // エンコード済が空欄にする
      this.query.cid = ''
      // バイナリが空欄にする
      this.cidBinary = ''

      // エラーメッセージが表示されない
      this.clearCheckError()

      // 更新ボタン：非活性
      this.btnUpdateDisable = true

      if (this.query.cidType == constants.CID_TYPE[0]) {
        // バイナリは書き込み可能
        this.readonlyBinary = false
        // エンコード済は書き込み不可
        this.readonlyEncoded = true

        // 背景色を設定する
        this.cidBgColor.binary = ''
        this.cidBgColor.encoded = 'gray'
      } else {
        // バイナリは書き込み不可
        this.readonlyBinary = true
        // エンコード済は書き込み可能
        this.readonlyEncoded = false

        // 背景色を設定する
        this.cidBgColor.binary = 'gray'
        this.cidBgColor.encoded = ''
      }
    },
    // 取得ボタン押下時
    search() {
      // エラーメッセージが表示されない
      this.clearCheckError()

      // 更新ボタン：非活性
      this.btnUpdateDisable = true

      // CID文字数が128文字を超える場合
      if (this.query.cid.length > constants.CID_MAXIMUM_NUMBER_OF_CHARACTERS
        || this.cidBinary.length > constants.CID_MAXIMUM_NUMBER_OF_CHARACTERS) {
          // エラー
          this.$alert(messages.CID_VALUE_LENGTH_OVER_ERROR, '提示', {
            confirmButtonText: 'OK',
            type: 'error'
          }).then(() => {
          }).catch(() => {
          })

          return
      }

      // 入力パラメータチェック
      if (this.query.cidType == constants.CID_TYPE[0]) {
        // エンコード済が空欄にする
        this.query.cid = ''

        // バイナリが空欄の場合
        if (this.cidBinary.length === 0) {
          // エラー
          this.$alert(messages.CID_VALUE_BLANK_ERROR, '提示', {
            confirmButtonText: 'OK',
            type: 'error'
          }).then(() => {
          }).catch(() => {
          })

          return
        }

        const isSuccess = this.hexTobase64String(this.cidBinary)
        if (!isSuccess) {
          // エラー
          this.$alert(messages.STRING_IS_NOT_HEX_ERROR, '提示', {
            confirmButtonText: 'OK',
            type: 'error'
          }).then(() => {
          }).catch(() => {
          })

          return
        }
      } else {
        // エンコード済が空欄の場合
        if (this.query.cid.length === 0) {
          // エラー
          this.$alert(messages.CID_VALUE_BLANK_ERROR, '提示', {
            confirmButtonText: 'OK',
            type: 'error'
          }).then(() => {
          }).catch(() => {
          })

          return
        }

        // Base64符号化された文字列をチェック
        const isBase64StrFlag = this.isBase64Str(this.query.cid)
        if (!isBase64StrFlag) {
          // エラー
          this.$alert(messages.STRING_IS_NOT_BASE64_ERROR, '提示', {
            confirmButtonText: 'OK',
            type: 'warning'
          }).then(() => {
          }).catch(() => {
          })

          return
        }
      }

      let querySearch = JSON.parse(JSON.stringify(this.query))
      // apiサービスコール
      axios.post(`${process.env.VUE_APP_BASE_URL}cid/search`, querySearch)
      .then((response) => {
        if (response.data.common.code === 'I10001') {
          // 成功の場合
          if (Object.keys(response.data.data).length === 0
            || Object.keys(response.data.data).length === 1 && Object.keys(response.data.data).indexOf('downloadDeadline') > -1) {
            // 検索条件に一致するデータが見つかりません
            this.$alert(messages.CID_SEARCH_NO_DATA_ERROR, '提示', {
              confirmButtonText: 'OK',
              type: 'error'
            }).then(() => {
            }).catch(() => {
            })
          } else {
            // 編集の制限、背景色設定
            this.propertyInit()

            if (typeof(response.data.data.cidProperty) != 'undefined') {
              // CidProperty情報を正常に表示する
              this.cidProrertyInfo = response.data.data.cidProperty

              // CidProperty情報が表示する
              this.isShowCidProrerty = true
            } else {
              // CidProperty情報が表示されない
              this.isShowCidProrerty = false
            }

            if (typeof(response.data.data.latestMapGuaranteeHistory) != 'undefined') {
              // LatestMapGuaranteeHistory情報を正常に表示する
              this.mapHistoryInfo = response.data.data.latestMapGuaranteeHistory

              // LatestMapGuaranteeHistory情報が表示する
              this.isShowMapHistory = true
            } else {
              // LatestMapGuaranteeHistory情報が表示されない
              this.isShowMapHistory = false
            }


            // responseデータ保存
            this.responseData = JSON.parse(JSON.stringify(response.data.data))

            // 対象環境と対象CIDラジオボタンが非活性であること
            this.disabled = true

            // バイナリは書き込み不可
            this.readonlyBinary = true,
            // エンコード済は書き込み不可
            this.readonlyEncoded = true
          }
        } else {
          // 失敗の場合
          this.$alert(`${response.data.common.message.join('<br/>')}(error code: ${response.data.common.code})`, '提示', {
            confirmButtonText: 'OK',
            dangerouslyUseHTMLString: true,
            type: 'error'
          }).then(() => {
          }).catch(() => {
          })
        }
      })
      .catch( (error) => {
        this.$alert(`${error.response.data.common.message.join('<br/>')}(error code: ${error.response.data.common.code})`, '提示', {
          confirmButtonText: 'OK',
          dangerouslyUseHTMLString: true,
          type: 'error'
        }).then(() => {
        }).catch(() => {
        })
      })
    },
    // クリアボタン押下時
    clear(query) {
      this.$confirm(messages.CLEAR_FOR_CONFIRM, '提示', {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(() => {
        // CidProperty情報が表示されない
        this.isShowCidProrerty = false

        // LatestMapGuaranteeHistory情報が表示されない
        this.isShowMapHistory = false

        // バイナリは書き込み可能
        this.readonlyBinary = false
        // エンコード済は書き込み可能
        this.readonlyEncoded = true

        // 対象環境と対象CIDラジオボタンが活性であること
        this.disabled = false

        // 更新ボタン：非活性
        this.btnUpdateDisable = true

        // 背景色を設定する
        this.cidBgColor.binary = ''
        this.cidBgColor.encoded = 'gray'

        // 検索条件を設定する
        this.query = {
          environment: constants.CHECK_FILE_NAME[2],
          cidType: constants.CID_TYPE[0],
          cid: ''
        }
        this.cidBinary = ''

        // エラーメッセージが表示されない
        this.clearCheckError()

        this.$message({
          type: 'info',
          message: messages.CLEAR_STATUS_SUCCESS,
          duration: constants.DURATION
        })

        this.$refs[query].resetFields()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: messages.CLEAR_STATUS_CANCEL,
          duration: constants.DURATION
        })
      })
    },
    // 更新ボタン押下時
    update() {
      // エラーメッセージが表示されない
      this.clearCheckError()

      // CidPropertyの黄色列情報
      let updateCidProrertyItems = {}
      let isYellowCid = false
      Object.keys(this.cidProrertyAttr).forEach((key) => {
        if (this.cidProrertyAttr[key].bgColor == constants.bgColor[1]) {
          isYellowCid = true

          // 黄色列を保存する
          updateCidProrertyItems[key] = this.cidProrertyInfo[key]
        }
      })

      // LatestMapGuaranteeHistoryの黄色列情報
      let updateMapHistoryItems = {}
      let isYellowHistory = false
      Object.keys(this.mapHistoryAttr).forEach((key) => {
        if (this.mapHistoryAttr[key].bgColor == constants.bgColor[1]) {
          isYellowHistory = true

          // 黄色列を保存する
          updateMapHistoryItems[key] = this.mapHistoryInfo[key]
        }
      })


      // テーブル名
      let dbTables = JSON.parse(JSON.stringify(constants.DEV_DB_TABLE_NAMES))
      if (this.query.environment == constants.CHECK_FILE_NAME[0]) {
        dbTables = JSON.parse(JSON.stringify(constants.PP_DB_TABLE_NAMES))
      }

      // 検索条件と更新後項目値
      let requestBody = {
        environment: this.query.environment,
        cid: this.query.cid,
        cidProperty: updateCidProrertyItems,
        latestMapGuaranteeHistory: updateMapHistoryItems,
      }

      if (!this.isShowCidProrerty || !isYellowCid) {
        delete requestBody.cidProperty
        delete dbTables[0]
      }

      if (!this.isShowMapHistory || !isYellowHistory) {
        delete requestBody.latestMapGuaranteeHistory
        delete dbTables[1]
      }


      // empty項を削除
      dbTables = dbTables.filter((d) => d)

      // 編集項目チェック
      const isCheckError = this.check()
      if (!isCheckError) {
        this.$confirm(messages.UPDATE_FOR_CONFIRM, '提示', {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }).then(() => {
          // apiサービスコール
          axios.post(`${process.env.VUE_APP_BASE_URL}cid/update`, requestBody)
          .then( (response) => {
            if (response.data.common.code === 'I10001') {
              const updateMessage = messages.UPDATE_DB_SUCCESS.replace('[0]', dbTables.join(constants.PAUSE_MARK))
              // 成功の場合
              this.$alert(updateMessage, '提示', {
                confirmButtonText: 'OK',
                type: 'success'
              }).then(() => {
                // DB検索を行う、更新後のデータを画面に再表示する
                this.search()
              }).catch(() => {
              })
            } else {
              // 失敗の場合
              this.$alert(`${response.data.common.message.join('<br/>')}(error code: ${response.data.common.code})`, '提示', {
                confirmButtonText: 'OK',
                dangerouslyUseHTMLString: true,
                type: 'error'
              }).then(() => {
              }).catch(() => {
              })
            }
          })
          .catch((error) => {
            Vue.$log.info('-----------------DB更新処理失敗の場合---------------------')
            Vue.$log.info(error)

            this.$alert(`${error.response.data.common.message.join('<br/>')}(error code: ${error.response.data.common.code})`, '提示', {
              confirmButtonText: 'OK',
              dangerouslyUseHTMLString: true,
              type: 'error'
            }).then(() => {
            }).catch(() => {
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: messages.UPDATE_STATUS_CANCEL,
            duration: constants.DURATION
          })
        })

      } else {
        return false
      }
    },
    // 編集項目チェック
    check() {
      // 初期化
      let isCheckError = false
      let wrongItemValues = new Array()

      // CidProperty情報: 黄色背景列をチェック
      Object.keys(this.cidProrertyAttr).forEach((itemCheck) => {
        if (this.cidProrertyAttr[itemCheck].bgColor == constants.bgColor[1]) {
          switch (itemCheck) {
            // all_update_term項目
            case Object.keys(constants.CID_PRORERTY)[1]:
              // チェック: 形式が「yyyy-MM-dd HH:mm:ss」であること（例："2021-12-20 10:20:36"）であること
              if (!constants.CID_REGULAR_RULES[1].test(this.cidProrertyInfo.all_update_term)) {
                wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
              } else {
                const dt = new Date(this.cidProrertyInfo.all_update_term)
                if (dt.toString() == 'Invalid Date') {
                  wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
                }
              }

              break
            // create_time項目
            case Object.keys(constants.CID_PRORERTY)[2]:
              // チェック: 形式が「yyyy-MM-dd HH:mm:ss」であること（例："2021-12-20 10:20:36"）であること
              if (!constants.CID_REGULAR_RULES[1].test(this.cidProrertyInfo.create_time)) {
                wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
              } else {
                const dt = new Date(this.cidProrertyInfo.create_time)
                if (dt.toString() == 'Invalid Date') {
                  wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
                }
              }

              break
            // diff_update_term項目
            case Object.keys(constants.CID_PRORERTY)[10]:
              // チェック: 形式が「yyyy-MM-dd HH:mm:ss」であること（例："2021-12-20 10:20:36"）であること
              if (!constants.CID_REGULAR_RULES[1].test(this.cidProrertyInfo.diff_update_term)) {
                wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
              } else {
                const dt = new Date(this.cidProrertyInfo.diff_update_term)
                if (dt.toString() == 'Invalid Date') {
                  wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
                }
              }

              break
            // initial_map_ver項目
            case Object.keys(constants.CID_PRORERTY)[3]:
              // チェック: 形式が「"半角数字2桁" + Q + "半角英数字7桁"」であること
              if (constants.RULES_IN_MAPS[0].test(this.cidProrertyInfo.initial_map_ver)) {
                true
              } else {
                wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
              }

              break
            // management_info項目
            case Object.keys(constants.CID_PRORERTY)[5]:
              // JSON形式チェック
              try {
                JSON.parse(this.cidProrertyInfo.management_info)
              } catch (error) {
                wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
              }

              break
            // run100k項目
            case Object.keys(constants.CID_PRORERTY)[8]:
              // チェック: 半角数値であること。範囲は0と1のみ
              if (!constants.CID_REGULAR_RULES[2].test(this.cidProrertyInfo.run100k)) {
                wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
              }

              break
            // start_date項目
            case Object.keys(constants.CID_PRORERTY)[7]:
              // チェック: 形式が「yyyy-MM-dd HH:mm:ss」であること（例："2021-12-20 10:20:36"）であること
              if (!constants.CID_REGULAR_RULES[1].test(this.cidProrertyInfo.start_date)) {
                wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
              } else {
                const dt = new Date(this.cidProrertyInfo.start_date)
                if (dt.toString() == 'Invalid Date') {
                  wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
                }
              }

              break
            // update_time項目
            case Object.keys(constants.CID_PRORERTY)[0]:
              // チェック: 形式が「yyyy-MM-dd HH:mm:ss」であること（例："2021-12-20 10:20:36"）であること
              if (!constants.CID_REGULAR_RULES[1].test(this.cidProrertyInfo.update_time)) {
                wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
              } else {
                const dt = new Date(this.cidProrertyInfo.update_time)
                if (dt.toString() == 'Invalid Date') {
                  wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[0], itemName: itemCheck})
                }
              }

              break
          }
        }
      })

      // LatestMapGuaranteeHistory情報: 黄色背景列をチェック 
      Object.keys(this.mapHistoryAttr).forEach((itemCheck) => {
        if (this.mapHistoryAttr[itemCheck].bgColor == constants.bgColor[1]) {
          switch (itemCheck) {
          // create_time項目
            case Object.keys(constants.LATEST_MAP_GUARANTEE_HISTORY)[0]:
              // チェック: 形式が「yyyy-MM-dd HH:mm:ss」であること（例："2021-12-20 10:20:36"）であること
              if (!constants.CID_REGULAR_RULES[1].test(this.mapHistoryInfo.create_time)) {
                wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[1], itemName: itemCheck})
              } else {
                const dt = new Date(this.mapHistoryInfo.create_time)
                if (dt.toString() == 'Invalid Date') {
                  wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[1], itemName: itemCheck})
                }
              }

              break
            // fs_applied項目
            case Object.keys(constants.LATEST_MAP_GUARANTEE_HISTORY)[1]:
              // チェック: 半角数値であること。範囲は0と1のみ
              if (!constants.CID_REGULAR_RULES[2].test(this.mapHistoryInfo.fs_applied)) {
                wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[1], itemName: itemCheck})
              }

              break
            // latest_map_ver項目
            case Object.keys(constants.LATEST_MAP_GUARANTEE_HISTORY)[3]:
              // チェック: 形式が「"半角数字2桁" + Q + "半角英数字7桁"」であること
              if (!constants.RULES_IN_MAPS[0].test(this.mapHistoryInfo.latest_map_ver)) {
                wrongItemValues.push({itemObj: constants.CID_CHECK_OBJ[1], itemName: itemCheck})
              }

              break
          }
        }
      })


      // エラー情報のタイトル
      let errorMessagesArray = new Array()
      if (wrongItemValues.length > 0) {
        isCheckError = true
        errorMessagesArray.push({'seq': 0, 'error': constants.CID_CHECK_TYPE[0]})
      }

      // エラー情報の内容
      for (let i in wrongItemValues) {
        let itemValuesError = messages.CID_ITEM_VALUES_WRONG_ERROR.replace('[0]', wrongItemValues[i].itemObj)
          .replace('[1]', wrongItemValues[i].itemName)
        errorMessagesArray.push({'seq': (parseInt(i) + 1)/1000, 'error': itemValuesError})
      }

      // エラー情報を表示する
      let errorMessages = commonUtil.objectArraySort(errorMessagesArray, 'seq', 'error')
      this.allErrorMessages = [{
        leftError: errorMessages.join(constants.LINE_BREAK),
        rightError: ''
      }]
      // エラーメッセージが表示されること
      this.styleType = 'display: block'

      return isCheckError
    },
    // エラー情報を表示しない
    clearCheckError() {
      this.allErrorMessages = [{
        leftError: '',
        rightError: ''
      }]

      // エラーメッセージが表示されない
      this.styleType = 'display: none'
    }
  }
}
</script>

<style>
#div-error-messages {
  margin: 0px 36px;
  width: 84.2%;
}
#div-error-messages .el-table .cell {
  white-space: pre-wrap;
  text-align : left;
  font-size: 12px;
  color:red;
  line-height: 1.5;
  padding-left: 0px;
}
.mt-cid-info {
  margin-top: 0px;
}
.radio-top {
  margin-top: 40px;
}
.input-binary-top {
  margin-top: -12px;
}
.input-encoded-top {
  margin-top: 12px;
}
.label-cid-style {
  max-width: 240px;
  min-width: 100px;
  color: white;
  margin: 0 auto;
  height: 80px;
  line-height: 5.5em;
  background: green;
}
.btn-update-center {
  text-align: center;
}
.div-style {
  margin-top: 40px;
}
.el-input__inner[BgColor="yellow"] {
  background-color: #ffff00;
}
.el-input__inner[BgColor="green"] {
  background-color: #e2efda;
}
.el-input__inner[BgColor="gray"] {
  background-color: #d9d9d9;
}
.el-textarea__inner[BgColor="yellow"] {
  background-color: #ffff00;
}
.el-textarea__inner[BgColor="green"] {
  background-color: #e2efda;
}
</style>